<template>
    <div class="layout-landing">
        <div class="layout-landing__content">
            <slot name="content" />
        </div>
        <div class="layout-landing__illustration">
            <slot name="illustration" />
        </div>
    </div>
</template>

<style lang="scss">
.global:has(.automation-landing) {
    // Overwrite global styles SAAS background for the automation templates layout (gray to white)
    background-color: var(--colors-common-background-default);
}
</style>

<style lang="scss" scoped>
.layout-landing {
    max-width: 1328px;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: 1fr;
    gap: var(--spacing-4);
    margin: auto;
    padding: 68px 0 0;

    &__content {
        grid-column: 2 / 6;
    }

    &__illustration {
        grid-column: 7 / 12;
        margin: auto;
    }

    @media (max-width: 1279px) {
        width: 426px;
        grid-template-rows: auto auto;
        padding: 0;

        &__illustration {
            grid-column: 1 / -1;
            order: 1;
        }

        &__content {
            grid-column: 1 / -1;
            order: 2;
        }
    }
}
</style>
